import React from "react";
import helpCircle from "../assets/help-circle.svg";

const InfoCard = ({
  title,
  titleColor = "#1F384C",
  value,
  tooltip,
  onClick,
}) => {
  return (
    <div
      className="rounded-2xl shadow-md p-7 bg-white relative cursor-pointer"
      style={{
        maxWidth: 235,
        flexGrow: 1,
        backgroundColor: "#FFFFFF",
        height: 112,
      }}
      onClick={onClick}
    >
      {/* Header */}
      <div className="flex justify-start items-center gap-2 mb-2">
        <span className="inter-semibold text-sm" style={{ color: titleColor }}>
          {title}
        </span>

        {/* Tooltip */}
        <div className="relative group flex justify-center items-center">
          <img
            src={helpCircle}
            className="w-4 h-4 cursor-pointer"
            style={{ borderColor: "#C1C1C1", color: "#8F99A6" }}
            alt="ayuda"
          />
          <div className="absolute hidden group-hover:flex flex-col items-center bg-white border text-[#595A5C] text-xs p-2 rounded-md shadow-md w-48 z-10 -top-12 left-1/2 -translate-x-1/2">
            {tooltip}
          </div>
        </div>
      </div>

      {/* Value */}
      <div
        className="inter-semibold text-2xl text-[#1C1C1C]"
        style={{ textAlign: "left" }}
      >
        {value}
      </div>
    </div>
  );
};

export default InfoCard;
